// src/auth/AuthContext.js
// Global "am I logged in?" state for the whole app.
// Wrap <App /> with <AuthProvider> in index.js (already done in the new App.js).

import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "./supabase";

const AuthContext = createContext({
  user: null,
  session: null,
  loading: true,
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1) Load existing session on mount (handles page reloads)
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    // 2) Subscribe to future auth changes (sign-in, sign-out, token refresh)
  const { data: sub } = supabase.auth.onAuthStateChange((event, newSession) => {
  setSession(newSession);
  if (event === "PASSWORD_RECOVERY" && window.location.pathname !== "/reset-password") {
    window.location.replace("/reset-password");
  }
});

    return () => sub.subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  const value = {
    user: session?.user || null,
    session,
    loading,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}